import type { ErrorResponse } from '~/types/error-responses.types';
import BaseException from './BaseException';

export default class NotFoundException extends BaseException {
  readonly name = 'NotFoundException';

  constructor(response?: ErrorResponse<any>) {
    super({
      errors: [
        {
          status: 404,
          id: 'web.error.resource_not_found',
          description: 'web.error.resource_not_found',
        },
      ],
      ...response,
    });
  }
}
